import parse from "html-react-parser";
import React, { useState, useEffect } from "react";
import api from "../../api";
import Typography from "@mui/material/Typography";

const isElementVisible = (ele) => {
  const element = document.getElementById(ele);
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

const Content = ({ e, id }) => {
  // const dispatch = useDispatch();
  const [countView, setcountView] = useState(true);
  useEffect(() => {
    // Создаём таймер, который обновляет время каждую секунду
    const timer = setInterval(() => {
      if (isElementVisible(id) && countView) {
        console.log(`Просмотр новости ${id}`);
        setcountView(false);
        api.sendView(id);
      }
    }, 1000);
    // Очистка таймера при размонтировании
    return () => {
      clearInterval(timer);
    };
  });
  // Пустой массив зависимостей: эффект выполняется только при монтировании
  return (
    <div id={id}>
      {" "}
      <Typography variant="body1" gutterBottom>
        {parse(e)}{" "}
      </Typography>
    </div>
  );
};

export default Content;
